import React, {createContext, useContext, useState, useCallback} from "react";
import {fetchNotes, createNote, updateNote, deleteNote} from "../api/api";

const NotesContext = createContext();

// custom hook to use the notes context
export const useNotes = () => useContext(NotesContext);

export const NotesProvider = ({children}) => {
    const [notes, setNotes] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchAllNotes = useCallback(async () => {
        try {
            const notesData = await fetchNotes();
            setNotes(notesData);
        } catch (error) {
            console.error("Error loading notes", error);
        } finally {
            setLoading(false);
        }
    }, []);

    const addNote = useCallback(async (note) => {
        try {
            const newNote = await createNote(note);
            setNotes((prevNotes) => [...prevNotes, newNote]);
        } catch (error) {
            console.error("Error creating note", error);
        }
    }, []);

    const editNote = useCallback(async (id, updatedData) => {
        try {
            const updatedNote = await updateNote(id, updatedData);
            setNotes((prevNotes) => prevNotes.map((note) => (note.id === id ? updatedNote : note)));
        } catch (error) {
            console.error("Error updating note", error);
        }
    }, []);

    const removeNote = useCallback(async (id) => {
        try {
            await deleteNote(id);
            setNotes((prevNotes) => prevNotes.filter((note) => note.id !== id));
        } catch (error) {
            console.error("Error deleting note", error);
        }
    }, []);

    return (
        <NotesContext.Provider value={{notes, loading, fetchAllNotes, addNote, editNote, removeNote}}>
            {children}
        </NotesContext.Provider>
    );
}